import React from "react";
import { logEvent } from "@Lib/analytics";
// import { QueryClient, QueryClientProvider } from "react-query";
import styles from "./Index.module.less";
import cx from "classnames";
import { Tooltip } from "antd";
import AdBySelfRefresh from "@Components/ad/AdBySelfRefresh";
import { postInitialCollect } from "@Services/common";
import { Common } from "@Api";
import { RightFillIcon } from "@t8891/icon";
import { host } from "@Services/url";
import { formatThousend } from "../../../../utils/helper";
import { formatNumberToUnitString } from "@t8891/utils";

// const queryClient = new QueryClient();

// const { postInitialCollect } = Common;

interface IProps {
  dataObj: {
    ads?: {
      adclick: string;
      appLink: string;
      id: number;
      image: string;
      subscript: number;
      tag: string;
      title: string;
      type: number;
    };
    /* 车款ID */
    kindId?: number;
    /* 图片 */
    thumb?: string;
    /* 厂牌名 */
    brandName?: string;
    /* 车款名 */
    kindName?: string;
    /* 价格 */
    price?: string;
    /* 月销量等其他文案 */
    modelNum?: string;
    /* 判断是否可以一键询价 */
    inquiry?: number;
    /* 厂牌ID */
    brandId?: number;
    /* 判断是否有配备 */
    specLink?: string;
    /* 判断是否有优惠礼包、价格 */
    maxDiscountPrice?: string;
    /* 图片的href */
    picHref: string;
    /* 一键询价的href */
    btnHref: string;
    /* seo 图片alt */
    alt?: string;
    /* 配备讲解 */
    equipMovieId?: number;
    [key: string]: any;
  };
  gaId: string;
  source: string;
  className?: string;
  onClickPic?: () => any;
  onClickBtn?: () => any;
}

const CarItem = (props: IProps) => {
  const { dataObj, onClickPic, source, gaId } = props;
  return (
    <section className={styles["list-container"]}>
      <div className={cx(styles["list-item"])} key={dataObj.kindId} style={{ padding: "8px 16px" }}>
        <a
          href={dataObj.picHref}
          target='_blank'
          className={styles["item-msg"]}
          id={`${gaId}KindsLinkToSummary`}
          onClick={() => onClickPic && onClickPic()}
        >
          <img
            src={dataObj.thumb}
            width="168"
            height="112"
            style={{ aspectRatio: "168/112" }}
            className={styles["item-img"]}
            alt={`${dataObj.alt ? dataObj.alt : `${dataObj.brandName || ""} ${dataObj.kindName || ""}`}`}
          />
          {`${dataObj.brandName} ${dataObj.kindName}`.length > 25 ? (
            <Tooltip title={`${dataObj.brandName || ""} ${dataObj.kindName || ""}`}>
              <p
                className={
                  "text-16 text-[#333] leading-24 mb-4 w-180 line-clamp-1 whitespace-normal break-all text-center"
                }
                style={{ wordWrap: "break-word" }}
              >{`${dataObj.brandName || ""} ${dataObj.kindName || ""}`}</p>
            </Tooltip>
          ) : (
            <p
              className={
                "text-16 text-[#333] leading-24 mb-4 w-180 line-clamp-1 whitespace-normal break-all text-center"
              }
              style={{ wordWrap: "break-word" }}
            >{`${dataObj.brandName || ""} ${dataObj.kindName || ""}`}</p>
          )}

          {dataObj.price && <p className={styles["item-price"]}>{dataObj.price}</p>}
          {dataObj.modelNum && <p className={styles["item-results"]}>{dataObj.modelNum}</p>}
        </a>
        <div className={"flex  flex-col justify-center items-center h-58"}>
          {dataObj.inquiry === 1 && (
            <div className={"flex items-center justify-between  mb-10"}>
              <a
                href={`/ask/price?b=${dataObj.brandId}&k=${dataObj.kindId}&source=${source}-分期購車&kindType=installment`}
                target='_blank'
                id={`${gaId}KindsLinkToAskPriceInstallment`}
                className='bg-[#3264FF] text-white w-84 flex justify-center items-center h-30 rounded-4 mr-12 hover:text-white'
              >
                分期購車
              </a>
              <a
                className='bg-[#FF4333] text-white w-84 flex justify-center items-center h-30 rounded-4 hover:text-white'
                target='_blank'
                id={
                  !!dataObj?.maxDiscountPrice ? `${gaId}KindsLinkToAskPriceDiscountPrice` : `${gaId}KindsLinkToAskPrice`
                }
                href={dataObj?.btnHref}
              >
                {!!dataObj?.maxDiscountPrice ? "領取優惠" : "一鍵詢價"}
              </a>
            </div>
          )}

          <div className='flex justify-center items-center'>
            <a
              id={`${gaId}KindsLinkToPhotoModelBalance`}
              href={`/photoModel-balance.html?k=${dataObj.kindId}`}
              target='_blank'
              className={"text-[#666666] text-14 hover:text-[#666666]"}
            >
              規格配備
            </a>
            <i className='w-1 h-16 mx-6 bg-[#E8E8E8]' />
            <a
              id={`${gaId}KindsLinkToArticleList`}
              href={`/kind-information/${dataObj.kindId}`}
              target='_blank'
              className={"text-[#666666] text-14 hover:text-[#666666]"}
            >
              編輯測評
            </a>
            <i className='w-1 h-16 mx-6 bg-[#E8E8E8]' />
            <a
              id={`${gaId}KindsLinkToRatingList`}
              href={`/kind-comment/${dataObj.kindId}`}
              target='_blank'
              className={"text-[#666666] text-14 hover:text-[#666666]"}
            >
              車友評價
            </a>
          </div>
        </div>

        {!!dataObj?.maxDiscountPrice && (
          <div className={styles["item-bag"]}>
            <p className={styles["bag-title"]}>最高優惠</p>
            <p className={styles["bag-price"]}>禮包{formatThousend(dataObj.maxDiscountPrice)}</p>
          </div>
        )}

        {dataObj.ads && (
          <AdBySelfRefresh
            data={dataObj.ads}
            first={true}
            refresh={() => postInitialCollect(dataObj.ads, "show", "")}
            styles={{ display: "inline-block" }}
          />
        )}
        {dataObj.ads && dataObj.ads.tag !== "" && <span className={styles["item-tag"]}>{dataObj.ads.tag}</span>}
      </div>

      <a
        id={`${gaId}MenusToSummary`}
        href={
          !!dataObj.menuCount
            ? `/buy-car/menu?brandId=${dataObj.brandId}&kindId=${dataObj.kindId}`
            : `/photoModel-info.html?k=${dataObj.kindId}`
        }
        target='_blank'
        style={{ background: "linear-gradient(90deg,#f2f7fe 5%, #d6e6fd)" }}
        className='w-full h-40 flex items-center justify-between text-[#666666] hover:text-[#666666] text-14 px-14 rounded-bl-4 rounded-br-4'
      >
        {!!dataObj.menuCount
          ? `${formatNumberToUnitString(Number(dataObj.menuCount) || 0, {
              needToLocalStringLessTenThousand: true,
              digist: 1,
            })}位車主分享成交行情`
          : dataObj.visitsRank}
        <span className='text-[#3264FF] '>查看</span>
      </a>
    </section>
  );
};

export default CarItem;
